import { browser } from '@dh-io-owpi/shared/src/environment';
import { isSmallVersion } from '../../composables/isSmallVersion';
import { computed, ref, watchEffect, type Ref } from 'vue';

export function usePinnedSalesBar(): {
  elRef: Ref<HTMLDivElement | undefined>;
  isPinned: Ref<boolean>;
} {
  const elRef = ref<HTMLDivElement>();

  if (!browser) return { elRef, isPinned: ref(false) };

  const isPinnedDesktop = ref(false);
  const isPinnedMobile = ref(false);

  const mObserver = new IntersectionObserver(([e]) => (isPinnedDesktop.value = e.boundingClientRect.top < 0), {
    threshold: 1,
  });

  const dObserver = new IntersectionObserver(([e]) => (isPinnedMobile.value = !e.isIntersecting), { threshold: 0.1 });

  watchEffect((onCleanup) => {
    const el = elRef.value;
    if (!el?.parentElement) return;

    mObserver.observe(el);
    dObserver.observe(el.parentElement);

    onCleanup(() => {
      mObserver.unobserve(el);
      dObserver.unobserve(el.parentElement!);
    });
  });

  const isPinned = computed(() => (isSmallVersion.value ? isPinnedMobile.value : isPinnedDesktop.value));

  return { elRef, isPinned };
}
